import { useMemo } from 'react';
import { appShortcuts } from 'src/constants/appShortcuts';
import { useGlobalStore } from 'src/store';
import { Modals, useShowModals } from 'src/store/modals';
import useNavigationStore from 'src/store/navigation';
import { useRegisterShortcuts } from './use-shortcuts';

export const useGlobalShortcuts = () => {
  const setActivePane = useNavigationStore((state) => state.setActivePane);
  const setNavbar = useGlobalStore.use.setNavbar();

  const [showConversationModal] = useShowModals(Modals.AddConversationModal);

  useRegisterShortcuts(
    useMemo(
      () => [
        {
          ...appShortcuts.openSearch,
          callback: () => {
            // open the in-nav compact search pane (its input autofocuses on mount)
            setNavbar({ isOpen: true });
            setActivePane('search');
            return false;
          },
        },
        {
          ...appShortcuts.openCreateConversation,
          callback: () => {
            showConversationModal();
            // the modal focuses its first field before the key's character is typed
            return false;
          },
        },
      ],
      [setActivePane, setNavbar, showConversationModal],
    ),
  );
};
